import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    sectionTitle: {
        margin: '40px 0px'
    },
    gridMargin: {
        margin: '50px 0px '
    },
    buttonMargin: {
        margin: '0px 0px 20px'
    },
    cardSpace: {
        [theme.breakpoints.up('sm')]: {
            padding: '20px 20px'
        },
        padding: '20px 20px',
        margin: '50px 20px',
        border: "solid 2px",
        borderColor: "#ff0000"


    },
    infoText: {
        margin: '0px 0px 10px'
    }
}));